module.exports = __webpack_public_path__ + "static/sailing-ship-a7606e80f70325cef25a8b0c339af88e.png";